var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var SportEventDetailsDialogAppealDeadlineInfo = function (_a) {
    var appealDeadline = _a.appealDeadline;
    var t = useTranslation().t;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (_jsxs("div", __assign({ className: "flex space-x-5 pt-10" }, { children: [_jsxs("div", __assign({ className: "w-180 text-14 text-gray" }, { children: [_jsxs("span", { children: [t('Дедлайн подачи апелляции'), ":\u00A0"] }, void 0), _jsx(Tooltip, __assign({ onMouseOver: function () { return setOpen(true); }, onMouseLeave: function () { return setOpen(false); }, onClose: function () { return setOpen(false); }, open: open, title: t('Дата, после которой нельзя внести изменения в зачёт турнирных таблиц, например через проверку тренировок администратором. После этой даты зачёты фиксируются.') || '', leaveTouchDelay: 10000, leaveDelay: 700, className: "text-white" }, { children: _jsx(InfoOutlinedIcon, { onClick: function () { return setOpen(!open); }, fontSize: "small" }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "flex md:max-w-840 items-center dark:text-white" }, { children: new Date(appealDeadline).toLocaleString() }), void 0)] }), void 0));
};
export default SportEventDetailsDialogAppealDeadlineInfo;
